import PropTypes from 'prop-types';

export default PropTypes.shape({
  epoch: PropTypes.number,
  hour: PropTypes.func,
  minute: PropTypes.func,
  tz: PropTypes.string,
});
